import axios from "axios";
import { serverURL,headeroption,headeroptionupload } from "../http-common";

class ServicingService {
  getallServicing(data) {
    return axios.get(serverURL + "/servicing-api?req=smarttableServicing", {
      params: data,
      headers: headeroption,
    })
  }
  getServicing(servicing_id) {
    return axios.get(serverURL + "/servicing-api?req=getServicing", {
      params: { servicing_id: servicing_id }, headers: headeroption,
    });
  }
  createServicing(data) {
    return axios.post(serverURL + "/servicing-api?req=createServicing", data, {
      headers: headeroption,
    });
  }
  updateServicing(data) {
    return axios.put(serverURL + "/servicing-api?req=updateServicing", data, {
      headers: headeroption,
    });
  }
  deleteServicing(servicing_id) {
    return axios.delete(serverURL + "/servicing-api?req=deleteServicing", { params: { servicing_id: servicing_id }, headers: headeroption, });
  }
  deleteAll() {
    return axios.delete(serverURL + "/servicing-api?req=deleteServicing");
  }
  findByTitle(servicing_name) {
    return axios.get(serverURL + "/servicing/servicing-api?name=" + servicing_name);
  }
  upload(servicing_id, data) {
    return axios.post(serverURL + "/uploads-api/singlefile?servicing_id=" + servicing_id, data, { headers: headeroptionupload });
  }
  uploads(servicing_id, data) {
    return axios.post(serverURL + "/uploads-api/uploadmultifile?servicing_id=" + servicing_id, data, { headers: headeroptionupload });
  }
}
export default new ServicingService();
